import {ModernizrModule} from './App/ModernizrModule';
import {SearchModule} from './App/SearchModule';
import {MenuModule} from './App/MenuModule';
import {LanguageSwitcherModule} from './App/LanguageSwitcherModule';
import {FilterModule} from './App/FilterModule';
import {PrintModule} from './App/PrintModule';
import {GoogleMapModule} from './App/Map/GoogleMapModule';
import {DropdownNavigationModule} from './App/DropdownNavigationModule';
import {ProductModule} from './App/ProductModule';
import { CarouselModule } from './App/CarouselModule';
import { YoutubeVideoModule } from './App/YoutubeVideoModule';
import { ScrollToTopModule } from './App/ScrollToTopModule';
import { FormModule } from './App/FormModule';

$(document).ready(function() {

	let modernizrModule = new ModernizrModule();
	let menuModule = new MenuModule();
	let searchModule = new SearchModule(menuModule);
	let languageSwitcherModule = new LanguageSwitcherModule();
	let filterModule = new FilterModule();
	let printModule = new PrintModule();
	let dropdownNavigationModule = new DropdownNavigationModule();
	let productModule = new ProductModule(dropdownNavigationModule);
	let carouselModule = new CarouselModule();
	let youtubeVideoModule = new YoutubeVideoModule();
	let scrollToTopModule = new ScrollToTopModule();
	let formModule = new FormModule();

	window.initGoogleMap = function() {
		let googleMapModule = new GoogleMapModule();
	};

	//Load googlemap only when map is present
	if ($("#ipco-map").length) {
		let apiKey = 'AIzaSyDK54Quw2P8Ez0PmSFsTNyRE524dFLOlIc';
		let src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&callback=initGoogleMap";
		$.getScript(src, function(data, textStatus, jqxhr) {});
	}
});

